module.exports = __webpack_public_path__ + "static/media/book-h2o-detail4.eb3323cc.jpg";